import React, { useMemo } from "react";
import styled from "styled-components";
import getConfig from "next/config";
import { isMobile } from "react-device-detect";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const { publicRuntimeConfig } = getConfig();

const StyledProductCard = styled.div`
  display: flex;
  align-items: flex-start;

  height: 100%;
  width: 100%;

  padding-top: ${({ popular }) => popular ? '30px' : '20px'};
  padding-bottom: 20px;
  padding-left: 40px;
  padding-right: 40px;

  box-shadow: 3px 3px 4px 0 rgb(0 0 0 / 41%);
  border: 1px solid #e0e0e0;

  cursor: pointer;

  position: relative;

  &:hover {
    box-shadow: 1px 1px 5px #cccccc;
  }

  :after {
    position: absolute;
    text-align: left;
    top: 0;
    left: 0;
    display: ${({ popular }) => popular ? 'block' : 'none'};
    padding: 3px 14px;
    color: #fff;
    font-weight: 400;
    font-size: 14px;
    line-height: calc(1.42857rem * (14 / 16));
    background-color: red;
    content: "MOST POPULAR";
  }

  .product-card-content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    
    width: 100%;

    .product-card-title {
      display: flex;
      justify-content: flex-start;

      font-family: 'RobotoBold';
      font-size: 21px;
      line-height: calc(1.42857rem * (21 / 16));
      color: #002346;
    }

    .product-card-description {
      display: flex;
      justify-content: flex-start;
      flex-grow: 1;
      
      font-family: 'RobotoBold';
      font-size: 14px;
      color: #212529;
    }
  }

  .product-card-icon {
    display: none;
  }

  @media ${({ theme }) => theme.devices.tablet} {
    padding-left: 20px;
    padding-right: 20px;

    :after {
      width: 100%;
    }

    .product-card-icon {
      display: flex;
      align-items: center;

      height: 100%;
      margin-left: 8px;

      img {
        height: 40px;
        width: 40px;
      }
    }
  }
`;

function ProductCard({ id, title, description, popular }) {
  const overlayTriggerProps = useMemo(() => {
    const props = {
      key: id,
      placement: isMobile ? "top" : "right",
      delay: { show: 0, hide: 0 },
      trigger: ["hover", "focus"],
      overlay: (
        <Tooltip id={`tooltip-${id}`}>
          {description}
        </Tooltip>
      ),
      show: false,
    };

    return props;
  }, [id, description]);

  return (
    <OverlayTrigger {...overlayTriggerProps}>
      <StyledProductCard tabIndex={0} popular={popular}>
        <div className="product-card-content">
          <div className="product-card-title">
            <span>{title}</span>
          </div>
          <div className="product-card-description">
            <span>{description}</span>
          </div>
        </div>
        <div className="product-card-icon">
          <img
            src={`${publicRuntimeConfig.basePath}/images/V2/V2-federal/right-arrow.png`}
            alt=""
            layout="fill"
          />
        </div>
      </StyledProductCard>
    </OverlayTrigger>
  );
}

export default ProductCard;
